export default "__VITE_ASSET__04a1c2f8__"